<template>
  <div>
    <div class="flex justify-center">
      <div class="flex justify-center lg:justify-start lg:w-5/6 w-full">
        <div
          class="flex justify-start lg:max-w-full max-w-xs flex-wrap lg:justify-evenly lg:px-8 w-full mt-5"
        >
          <div
            :class="`${
              wFull ? 'lg:w-auto' : 'lg:w-1/3'
            } mb-8 w-1/3 text-center`"
            v-for="(item, index) in dias"
            :key="index"
          >
            <vs-button
              class="w-12 h-12 lg:w-20 lg:h-20 lg:text-2xl btn-type-calendar"
              radius
              :class="{
                'btn-selected': isClicked(item),
              }"
              @click.stop.prevent="selecionaDia(item)"
              type="border"
              >{{ item }}</vs-button
            >
          </div>
        </div>
      </div>
    </div>
    <h5 class="mt-5">Simulação Próximas Faturas</h5>
    <vs-list>
      <vs-list-item
        v-for="(item, index) in proximosVencimentos"
        :key="index"
        :title="item"
        icon-pack="feather"
        icon="icon-calendar"
      ></vs-list-item>
    </vs-list>
  </div>
</template>

<script>
import dateFunctions from '../../utils/dateConversion';
export default {
  name: 'dateRadio',
  props: {
    diasDisponiveis: Array,
    diaJaDefinido: Number,
    wFull: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dias: this.diasDisponiveis,
      diaSelecionado: null,
      proximosVencimentos: null,
    };
  },
  methods: {
    /**
     * Selects a specific day and triggers related actions.
     *
     * @param {number} dia - The selected day.
     * @returns {void}
     * @emits diaSelecionado - Emitted when a day is selected with the selected day as payload.
     */
    selecionaDia(dia) {
      this.diaSelecionado = dia;
      this.listVencimentos(this.diaSelecionado);
      this.$emit('diaSelecionado', this.diaSelecionado);
    },

    /**
     * Lists the upcoming due dates based on the selected day.
     *
     * @param {number} dia - The selected day for calculating due dates.
     * @returns {void}
     */
    listVencimentos(dia) {
      this.proximosVencimentos = dateFunctions.proximosVencimentos(dia);
    },

    /**
     * Checks if a value is equal to either the selected day or a previously defined day.
     *
     * @param {number} value - The value to compare with the selected day or a previously defined day.
     * @returns {boolean} - True if the value is equal to the selected day or a previously defined day, otherwise false.
     */
    isClicked(value) {
      const isClicked = this.diaSelecionado === value;
      return isClicked;
    },
  },
  mounted() {
    if (this.diaJaDefinido) {
      this.selecionaDia(this.diaJaDefinido);
    }
  },
};
</script>

<style>
.btn-type-calendar.vs-button-primary.vs-button-border,
.vs-button-primary.vs-button-flat {
  background: #f0f0f0 !important;
  border: none;
  color: #626262;
}
.btn-selected.vs-button-primary.vs-button-border,
.vs-button-primary.vs-button-flat {
  background-color: rgba(var(--vs-primary), 1) !important;
  color: white;
}
</style>
